/* eslint-disable max-len */

import { GetCarMileageResponse } from '@1po/1po-bff-fe-spec/generated/catalog/maintenance_plan/response/GetCarMileageResponse';
import { GetPlannedOperationsResponse } from '@1po/1po-bff-fe-spec/generated/catalog/maintenance_plan/response/GetPlannedOperationsResponse';
import { ServiceOperation } from '@1po/1po-bff-fe-spec/generated/catalog/service_operations/model/ServiceCategory';
import {
  FamilyReference,
  GetIAMFamilyReferencesResponse,
} from '@1po/1po-bff-fe-spec/generated/catalog/service_operations/response/GetIAMFamilyReferencesResponse';
import { GetIAMServiceChecklistResponse } from '@1po/1po-bff-fe-spec/generated/catalog/service_operations/response/GetIAMServiceChecklistResponse';
import {
  GetIAMServiceOperationsResponse,
  ServiceCategory,
} from '@1po/1po-bff-fe-spec/generated/catalog/service_operations/response/GetIAMServiceOperationsResponse';
import { GetIAMServiceProposalOperationsResponse } from '@1po/1po-bff-fe-spec/generated/catalog/service_operations/response/GetIAMServiceProposalOperationsResponse';
import { GetIAMServiceProposalResponse } from '@1po/1po-bff-fe-spec/generated/catalog/service_operations/response/GetIAMServiceProposalResponse';
import moment from 'moment';
import { APP_NAMESPACE } from 'app/App.constants';
import { NO_DATA, SearchData } from 'utils';

export const MAINTENANCE_PLAN_NAMESPACE = `${APP_NAMESPACE}/MAINTENANCE_PLAN`;

export const ADD_OPERATION = `${MAINTENANCE_PLAN_NAMESPACE}/ADD_OPERATION`;
export const REMOVE_OPERATION = `${MAINTENANCE_PLAN_NAMESPACE}/REMOVE_OPERATION`;
export const SET_OPERATIONS = `${MAINTENANCE_PLAN_NAMESPACE}/SET_OPERATIONS`;
export const SET_REFERENCES = `${MAINTENANCE_PLAN_NAMESPACE}/SET_REFERENCES`;
export const ADD_REFERENCES = `${MAINTENANCE_PLAN_NAMESPACE}/ADD_REFERENCES`;
export const REMOVE_REFERENCES = `${MAINTENANCE_PLAN_NAMESPACE}/REMOVE_REFERENCES`;
export const SET_PROPOSAL_REGISTRATION_DATE_INPUT = `${MAINTENANCE_PLAN_NAMESPACE}/SET_PROPOSAL_REGISTRATION_DATE_INPUT`;
export const SET_PROPOSAL_MILEAGE_INPUT = `${MAINTENANCE_PLAN_NAMESPACE}/SET_PROPOSAL_MILEAGE_INPUT`;
export const SET_PROPOSAL_OPTION_INPUT = `${MAINTENANCE_PLAN_NAMESPACE}/SET_PROPOSAL_OPTION_INPUT`;
export const GET_IAM_SERVICE_PROPOSALS_REQUEST = `${MAINTENANCE_PLAN_NAMESPACE}/GET_IAM_SERVICE_PROPOSALS_REQUEST`;
export const GET_IAM_SERVICE_PROPOSAL_OPERATIONS_REQUEST = `${MAINTENANCE_PLAN_NAMESPACE}/GET_IAM_SERVICE_PROPOSAL_OPERATIONS_REQUEST`;
export const GET_IAM_SERVICE_CHECKLIST_REQUEST = `${MAINTENANCE_PLAN_NAMESPACE}/GET_IAM_SERVICE_CHECKLIST_REQUEST`;
export const GET_IAM_REPAIR_METHOD_DETAIL_REQUEST = `${MAINTENANCE_PLAN_NAMESPACE}/GET_IAM_REPAIR_METHOD_DETAIL_REQUEST`;

export const GET_RD_CAR_MILEAGE_REQUEST = `${MAINTENANCE_PLAN_NAMESPACE}/GET_RD_CAR_MILEAGE_REQUEST`;
export const GET_RD_PLANNED_OPERATIONS = `${MAINTENANCE_PLAN_NAMESPACE}/GET_RD_PLANNED_OPERATIONS`;

export type mileage_units = 'km' | 'miles';
export const KM_TO_MILES = 0.621371;
export const MILES_TO_KM = 1.60934;

export interface MaintenancePlanState {
  vehicleKey: string | NO_DATA;
  vehicleCode: string | NO_DATA;
  serviceOperationsIAM: GetIAMServiceOperationsResponseLocal | NO_DATA;
  serviceOperationsFamiliesIAM: GetIAMFamilyReferencesResponse | NO_DATA;
  //<k - operation id, v - list of references with quantities>
  serviceOperationsReferences: Map<string, ServiceReferenceLocal[]>;
  registrationDate: NO_DATA | moment.Moment;
  serviceProposalsIAM: NO_DATA | GetIAMServiceProposalResponse;
  serviceProposalsOperationsIAM: NO_DATA | GetIAMServiceProposalOperationsResponse;
  mileage: NO_DATA | number;
  option: NO_DATA | string;
  serviceChecklist: SearchData<GetIAMServiceChecklistResponse> | undefined;
  //<k - categoryId, v - html page>
  repairMethodDetails: Map<string, SearchData<string> | undefined>;
  //R/D/A brands specific
  vinToMileage: Map<string, SearchData<GetCarMileageResponse> | undefined>;
  operationsProposal: Map<string, SearchData<GetPlannedOperationsResponseLocal> | undefined>;
}

export interface GetPlannedOperationsResponseLocal extends GetPlannedOperationsResponse {
  baseMileage?: number;
}

export interface ServiceReferenceLocal {
  referenceNumber: string;
  quantity: number;
  family: string;
  supplierCode?: string;
  origin?: FamilyReference['origin'];
  referenceSource?: FamilyReference['referenceSource'];
}

export interface ServiceOperationLocal extends ServiceOperation {
  selected?: boolean;
  subOperations?: ServiceCategoryLocal[];
}

export interface ServiceCategoryLocal extends ServiceCategory {
  operations: ServiceOperationLocal[];
}

export interface GetIAMServiceOperationsResponseLocal extends GetIAMServiceOperationsResponse {
  mainOperations?: ServiceCategoryLocal[];
  additionalOperations?: ServiceCategoryLocal[];
}
